import { importRegistry } from "../import-registry";
import { MdLocationOn, MdAccessTime } from "react-icons/md";

const reactIconsMd = "react-icons/md";
importRegistry.registerImports([
  [MdLocationOn, "MdLocationOn", "named", reactIconsMd],
  [MdAccessTime, "MdAccessTime", "named", reactIconsMd],
]);
